// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import LoadIframeController from "./load_iframe_controller"
application.register("load-iframe", LoadIframeController)

import MapboxRoutesController from "./mapbox_routes_controller"
application.register("mapbox-routes", MapboxRoutesController)

import CallsModalController from "./calls_modal_controller"
application.register("calls-modal", CallsModalController)

import SocialShareController from "./social_share_controller"
application.register("social-share", SocialShareController)

import TrixLinksController from "./trix_links_controller"
application.register("trix-links", TrixLinksController)

import TurboDialogController from "./turbo_dialog_controller"
application.register("turbo-dialog", TurboDialogController)

import Users__AddUserInterestsController from "./users/add_user_interests_controller"
application.register("users--add-user-interests", Users__AddUserInterestsController)

import ScrollRevealController from '@stimulus-components/scroll-reveal'
application.register('scroll-reveal', ScrollRevealController)

import NewsmanController from './newsman_controller'
application.register('newsman', NewsmanController)

import Users__PasswordController from "./users/password_controller"
application.register("users--password", Users__PasswordController)

import Notification from '@stimulus-components/notification'
application.register('notification', Notification)

import Lightbox from "@stimulus-components/lightbox"
application.register('lightbox', Lightbox)

// Imported from Gov template: ./templates/stejar.templates.gov/app/javascripts/controllers
import PdfEmbedController from "./pdf_embed_controller"
application.register("pdf-embed", PdfEmbedController)

import RevealController from '@stimulus-components/reveal'
application.register('reveal', RevealController)
 
import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import SearchListController from "./search_list_controller"
application.register("search-list", SearchListController)
